import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { formatFingerprintMetric } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-advanced-electrical',
  templateUrl: './advanced-electrical.component.html',
  styleUrls: ['../../summary-panels.css', './advanced-electrical.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintAdvancedElectricalComponent {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly formatValue = formatFingerprintMetric;
  readonly metrics = [
    { field: 'fElectricalPowerMean', label: 'میانگین ولتاژ', unit: 'V' },
    { field: 'fElectricalPowerStd', label: 'انحراف معیار ولتاژ', unit: 'V' },
    { field: 'fElectricalDeltaMean', label: 'میانگین تغییر ولتاژ', unit: 'V' },
    { field: 'fElectricalDeltaStd', label: 'انحراف معیار تغییرات', unit: 'V' },
    { field: 'fElectricalUnchangedMean', label: 'نسبت ولتاژ ثابت', unit: '%' },
    { field: 'fElectricalUnchangedStd', label: 'پراکندگی نسبت ثابت', unit: '' },
    { field: 'fElectricalLargeChangeMean', label: 'نسبت تغییرات بزرگ', unit: '%' },
    { field: 'fElectricalLargeChangeStd', label: 'پراکندگی تغییرات بزرگ', unit: '' },
  ] as const;
}
